import { converters as tableConverters } from 'store/table';
import { loaders } from './admin-content-reviews.loaders';
import {
  ContentReviewDetails,
  ContentReviewField,
  ContentReviewListItem,
} from './admin-content-reviews.types';

const convertListItem = (
  item: ContentReviewListItem,
): ContentReviewListItem => {
  return {
    ...item,
    itemType: item.itemType ?? null,
  };
};

const convertField = (field: ContentReviewField): ContentReviewField => ({
  ...field,
  children: field.children?.map(convertField),
});

const convertDetails = (item: ContentReviewDetails): ContentReviewDetails => ({
  ...item,
  itemType: item.itemType ?? null,
  fields: item.fields.map(convertField),
});

export const converters = {
  getContentReviews: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getContentReviews>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: data.data.map(convertListItem),
      total,
      page,
      pageSize,
      pages,
    };
  },
  getPendingCount: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getPendingCount>>) => data.count,
  getContentReview: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getContentReview>>) =>
    convertDetails(data),
};
